import { Link } from 'react-router-dom'

export default function TermsOfServicePage() {
  return (
    <div className="min-h-screen bg-gray-50 dark:bg-gray-900 py-12 px-4">
      <div className="max-w-3xl mx-auto">
        <Link
          to="/login"
          className="inline-flex items-center gap-2 text-primary-600 hover:text-primary-700 mb-8"
        >
          <i className="fas fa-arrow-left"></i>
          Back to Login
        </Link>

        <div className="bg-white dark:bg-gray-800 rounded-2xl shadow-lg p-8">
          <h1 className="text-3xl font-bold text-gray-900 dark:text-white mb-6">Terms of Service</h1>
          <p className="text-gray-500 dark:text-gray-400 mb-8">Last updated: January 2025</p>

          <div className="prose dark:prose-invert max-w-none">
            <h2 className="text-xl font-semibold text-gray-900 dark:text-white mt-6 mb-4">1. Acceptance of Terms</h2>
            <p className="text-gray-600 dark:text-gray-300 mb-4">
              By accessing and using the Jasmine Dental Lab Operations & Billing System, you agree to be
              bound by these Terms of Service. If you do not agree to these terms, please do not use our services.
            </p>

            <h2 className="text-xl font-semibold text-gray-900 dark:text-white mt-6 mb-4">2. Service Description</h2>
            <p className="text-gray-600 dark:text-gray-300 mb-4">
              Jasmine Dental Lab provides dental laboratory services including but not limited to:
            </p>
            <ul className="list-disc pl-6 text-gray-600 dark:text-gray-300 mb-4 space-y-2">
              <li>Dental prosthetics fabrication (crowns, bridges, dentures)</li>
              <li>Implant restorations</li>
              <li>Orthodontic appliances</li>
              <li>Digital dentistry services</li>
            </ul>

            <h2 className="text-xl font-semibold text-gray-900 dark:text-white mt-6 mb-4">3. User Accounts</h2>
            <p className="text-gray-600 dark:text-gray-300 mb-4">
              Users are responsible for maintaining the confidentiality of their account credentials.
              You must immediately notify us of any unauthorized use of your account.
            </p>

            <h2 className="text-xl font-semibold text-gray-900 dark:text-white mt-6 mb-4">4. Orders and Payments</h2>
            <ul className="list-disc pl-6 text-gray-600 dark:text-gray-300 mb-4 space-y-2">
              <li>All work orders are subject to acceptance by Jasmine Dental Lab</li>
              <li>Prices are as quoted at the time of order placement</li>
              <li>Payment terms are Net 30 unless otherwise agreed</li>
              <li>All invoices include applicable GST as per Indian tax laws</li>
              <li>Late payments may incur additional charges</li>
            </ul>

            <h2 className="text-xl font-semibold text-gray-900 dark:text-white mt-6 mb-4">5. Quality and Returns</h2>
            <p className="text-gray-600 dark:text-gray-300 mb-4">
              We strive to deliver high-quality dental products. If you are unsatisfied with any work:
            </p>
            <ul className="list-disc pl-6 text-gray-600 dark:text-gray-300 mb-4 space-y-2">
              <li>Report issues within 7 days of delivery</li>
              <li>We will remake or adjust products at no additional cost if the issue is due to our error</li>
              <li>Remakes due to changes in specifications may incur additional charges</li>
            </ul>

            <h2 className="text-xl font-semibold text-gray-900 dark:text-white mt-6 mb-4">6. Intellectual Property</h2>
            <p className="text-gray-600 dark:text-gray-300 mb-4">
              All content, designs, and software in this system are the property of Jasmine Dental Lab
              and are protected by intellectual property laws.
            </p>

            <h2 className="text-xl font-semibold text-gray-900 dark:text-white mt-6 mb-4">7. Limitation of Liability</h2>
            <p className="text-gray-600 dark:text-gray-300 mb-4">
              Jasmine Dental Lab's liability is limited to the value of the specific work order in question.
              We are not liable for indirect, consequential, or incidental damages.
            </p>

            <h2 className="text-xl font-semibold text-gray-900 dark:text-white mt-6 mb-4">8. Governing Law</h2>
            <p className="text-gray-600 dark:text-gray-300 mb-4">
              These terms are governed by the laws of India. Any disputes shall be subject to the
              exclusive jurisdiction of courts in Bangalore, Karnataka.
            </p>

            <h2 className="text-xl font-semibold text-gray-900 dark:text-white mt-6 mb-4">9. Changes to Terms</h2>
            <p className="text-gray-600 dark:text-gray-300 mb-4">
              We reserve the right to modify these terms at any time. Users will be notified of
              significant changes via email or system notification.
            </p>

            <h2 className="text-xl font-semibold text-gray-900 dark:text-white mt-6 mb-4">10. Contact</h2>
            <p className="text-gray-600 dark:text-gray-300">
              For questions about these terms, please contact:<br />
              <strong>Email:</strong> legal@jasminedental.com<br />
              <strong>Phone:</strong> +91 98765 43210
            </p>
          </div>
        </div>
      </div>
    </div>
  )
}
